export type Skill = {
  name: string;
  description: string;
  repo: string;
  tags: string[];
};

export const skills: Skill[] = [
  {
    name: "Secret Manager",
    description:
      "A skill for managing secrets directly from your CLI. Store, retrieve, and rotate API keys and credentials with Double O.",
    repo: "fjfok/double-o-secret-manager",
    tags: ["secrets", "cli", "management"],
  },
];
